import { PessoaListaRequest } from "./pessoa-lista.request";

export class PessoaImpressaoAniversarianteRequest extends PessoaListaRequest {
    public diaInicio: number;
    public mesInicio: number;
    public diaFim: number;
    public mesFim: number;
}